import { useState } from "react";
import { useNavigate } from "react-router-dom";

const HighlightSection = ({ isDarkMode, onSectionChange }) => {
  const [activeSection, setActiveSection] = useState("highlights");
  const navigate = useNavigate();

  // Mobile sections (includes countries)
  const mobileSections = [
    { id: "highlights", label: "Highlights" },
    { id: "countries", label: "Countries" },
    { id: "topgames", label: "Top Games" },
    { id: "upcoming", label: "Upcoming" },
  ];

  // Desktop sections (no countries)
  const desktopSections = [
    { id: "highlights", label: "Highlights" },
    { id: "topgames", label: "Top Games" },
    { id: "upcoming", label: "Upcoming" },
  ];

  const handleSectionClick = (sectionId) => {
    // Check if on mobile and clicked countries
    const isMobile = window.matchMedia("(max-width: 767px)").matches;

    if (isMobile && sectionId === "countries") {
      // Navigate to countries page on mobile
      navigate("/countries");
      return;
    }

    setActiveSection(sectionId);
    if (onSectionChange) {
      onSectionChange(sectionId);
    }
  };

  return (
    <div className="border-b-[1px] border-solid border-extralightblue dark:border-lightborderyellow">
      {/* Mobile Layout - with Sports title */}
      <div className="md:hidden">
        <div className="flex items-center justify-between p-[8px_15px_5px]">
          <span className="text-mutedblue dark:text-white text-[18px] font-bold leading-[160%]">
            Sports
          </span>
        </div>
        <div className="flex overflow-x-auto scrollbar-hide p-[0px_8px_5px]">
          {mobileSections.map((section) => (
            <button
              key={section.id}
              onClick={() => handleSectionClick(section.id)}
              className={`
                flex-shrink-0 px-2 py-1 mr-3 text-sm font-medium rounded-full transition-all duration-300
                ${
                  activeSection === section.id
                    ? "bg-darkblue dark:bg-yellow text-white dark:text-black"
                    : "bg-gray-100 dark:bg-darktitleColor text-mutedblue dark:text-yellow hover:bg-gray-200 dark:hover:bg-gray-600"
                }
              `}
            >
              {section.label}
            </button>
          ))}
        </div>
      </div>

      {/* Desktop Layout */}
      <div className="hidden md:block">
        <div className="flex items-center justify-center p-[5px_5px]">
          {desktopSections.map((section, index) => (
            <button
              key={section.id}
              onClick={() => handleSectionClick(section.id)}
              className={`
                relative px-6 py-2 text-sm s18:text-base font-medium transition-all duration-300
                ${
                  activeSection === section.id
                    ? "text-darkblue dark:text-yellow after:w-full after:bg-darkblue dark:after:bg-yellow"
                    : "text-[#737373] dark:text-white after:w-[0px]"
                }
                after:absolute after:content-[''] after:bg-darkblue after:left-[50%] after:translate-x-[-50%] 
                after:h-[2px] after:mx-auto after:bottom-0 after:transition-all after:duration-[0.3s] 
                hover:text-darkblue dark:hover:text-yellow hover:after:w-full dark:hover:after:bg-yellow
                ${index < desktopSections.length - 1 ? "mr-8" : ""}
              `}
            >
              {section.label}
            </button>
          ))}
        </div>
      </div>

      {/* Custom scrollbar hide styles */}
      <style jsx>{`
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </div>
  );
};
export default HighlightSection;
